export default {
    init() {
        this.auctionInnerApproveBidToggle();
        this.auctionInnerCancelBidToggle();
        this.auctionInnerNegotiations();
    },

    auctionInnerApproveBidToggle(){
        let popUp = $('.bid-approve-popup');
        popUp.hide();

        $('.approve-bid').on('click',function(){
            popUp.fadeIn(300);
        });

        $('.bid-approve-popup .close-pop').on('click',function(){
            popUp.fadeOut(300);
        });
    },

    auctionInnerCancelBidToggle(){
        let popUp = $('.bid-cancel-popup');
        popUp.hide();

        $('.cancel-bid').on('click',function(){
            popUp.fadeIn(300);
        });

        $('.bid-cancel-popup .close-pop').on('click',function(){
            popUp.fadeOut(300);
        });
    },

    auctionInnerNegotiations(){
        let popUp = $('.negotiations-popup');
        popUp.hide();

        $('.negotiation-show').on('click',function(){
            popUp.fadeIn(300);
        });

        $('.negotiations-popup .close-pop').on('click',function(){
            popUp.fadeOut(300);
        });
    }
}